import { ReactElement } from 'react';
import * as S from './ErrorMessage.styles';

const ErrorMessage = (): ReactElement => {
    return (
        <S.ErrorMessageWrapper>
            <S.LeftPart>
                <S.ErrorIcon />
            </S.LeftPart>
            <S.RightPart>
                <S.ErrorMessageTitle>
                    We couldn&apos;t complete your payment. Let&apos;s fix that!
                </S.ErrorMessageTitle>
                <S.ErrorMessageText>
                    Sometimes payments don&apos;t go through for simple reasons like card limits,
                    incorrect card numbers, or bank security checks.
                    <br />
                    <br />
                    ✅ Try again using the same card
                    <br />
                    💳 Use a different card or payment method
                    <br />
                    📞 If you still are having trouble, give us a quick call at{' '}
                    <strong>
                        <a href="tel:850-424-5125">850-424-5125</a>
                    </strong>{' '}
                    (9AM-5PM CST) — we&apos;re here to help and can reserve your spot right away!
                    <br />
                    <br />
                    We&apos;re holding your items for a short time — don&apos;t miss out!
                </S.ErrorMessageText>
            </S.RightPart>
        </S.ErrorMessageWrapper>
    );
};

export { ErrorMessage };
export default ErrorMessage;
